/* CANFOTO PERFORMANCE P1-R2C
   Makeup/RGB — sharded payload + idle near-viewport mount + per-theme font dedupe.
   Preserves persistent iframe: theme changes update CSS/copy without video restart.
*/
(() => {
  'use strict';

  if(window.__CANFOTO_MAKEUP_P1R2C__)return;
  window.__CANFOTO_MAKEUP_P1R2C__=true;

  const VERSION="CANFOTO-PERFORMANCE-P1-R2D-MAKEUP-OBSERVER-CONSOLIDATED";
  const CORE_GLOBAL="__CANFOTO_MAKEUP_P1R2C_CORE__";
  const THEMES_GLOBAL="__CANFOTO_MAKEUP_P1R2C_THEMES__";
  const TARGET_PRODUCT_URL="https://www.canfoto.com/products/gdx-ml-200r-ii-200w-rgb-profesyonel-studyo-ve-urun-cekim-isik-kiti";
  const LEGACY_PAYLOAD_RAW_BYTES=1173996;
  const CORE_RAW_BYTES=16751;
  const THEME_RAW_BYTES={"editorial":128250,"magazine":128461,"nature":128612,"newsroom":128967,"retrofuture":129274,"redaxis":129077,"chrome":128675,"cinema":128582,"hyperpop":129338};
  const ROOT_MARGIN='280px 0px';
  const IDLE_TIMEOUT=520;

  const ALIAS={'cf-editorial':'editorial','cf-magazine':'magazine','cf-nature':'nature','cf-newsroom':'newsroom','cf-retrofuture':'retrofuture','cf-redaxis':'redaxis','cf-chrome':'chrome','cf-cinema':'cinema','cf-hyperpop':'hyperpop'};
  const THEME_DATASET_KEYS={"editorial":"cf61ThemeEditorialUrl","magazine":"cf61ThemeMagazineUrl","nature":"cf61ThemeNatureUrl","newsroom":"cf61ThemeNewsroomUrl","retrofuture":"cf61ThemeRetrofutureUrl","redaxis":"cf61ThemeRedaxisUrl","chrome":"cf61ThemeChromeUrl","cinema":"cf61ThemeCinemaUrl","hyperpop":"cf61ThemeHyperpopUrl"};
  const mq=matchMedia('(max-width:720px)');

  const P1C_STATE=window.CANFOTO_P1C_OBSERVER_CONSOLIDATION_STATE=
    window.CANFOTO_P1C_OBSERVER_CONSOLIDATION_STATE||{
      version:'CANFOTO-PERFORMANCE-P1-C-OBSERVER-CONSOLIDATION-R2',
      makeup:{},
      homeControls:{}
    };

  let corePromise=null;
  const themePromises=new Map();
  let idleHandle=0;
  let idleKind='NONE';

  const cleanText=v=>String(v||'').replace(/\s+/g,' ').trim();

  function activeTheme(){
    const raw=cleanText(document.documentElement.dataset.cfTheme);
    if(ALIAS[raw])return ALIAS[raw];

    const fallback=cleanText(
      document.body?.getAttribute('data-cf45-experience') ||
      document.body?.getAttribute('data-cf-experience')
    );

    return ALIAS[fallback]||fallback.replace(/^cf-/,'')||'cinema';
  }

  function ensureThemeRegistry(){
    window[THEMES_GLOBAL]=window[THEMES_GLOBAL]||{};
    return window[THEMES_GLOBAL];
  }

  function enforceTargetCta(sec){
    if(!sec)return null;
    const cta=[...sec.querySelectorAll('a.cf61-makeup-campaign__cta')]
      .find(a=>/GDX\s*ML-200R\s*II/i.test(cleanText(a.textContent)));

    if(!cta)return null;
    if(cta.getAttribute('href')!==TARGET_PRODUCT_URL)cta.setAttribute('href',TARGET_PRODUCT_URL);
    cta.dataset.cf61CanonicalProductUrl='P1-R2C';
    return cta;
  }

  function ensureMounted(){
    const sec=document.querySelector('[data-cf61-makeup-campaign-r2h]');
    if(!sec){
      document.documentElement.dataset.cfHomeMakeupCampaignMount='STATIC_SECTION_MISSING';
      return null;
    }

    enforceTargetCta(sec);
    document.documentElement.dataset.cfHomeMakeupCampaignMount='STATIC_SHOPIFY_SECTION';
    return sec;
  }

  function loadScriptOnce(url,marker,ready){
    if(ready())return Promise.resolve(ready());

    const existing=document.querySelector(`script[${marker}="1"]`);
    if(existing){
      return new Promise((resolve,reject)=>{
        const now=ready();
        if(now){resolve(now);return;}
        existing.addEventListener('load',()=>{
          const value=ready();
          value?resolve(value):reject(new Error('SCRIPT_GLOBAL_MISSING'));
        },{once:true});
        existing.addEventListener('error',reject,{once:true});
      });
    }

    return new Promise((resolve,reject)=>{
      const script=document.createElement('script');
      script.src=url;
      script.async=true;
      script.setAttribute(marker,'1');
      script.addEventListener('load',()=>{
        const value=ready();
        value?resolve(value):reject(new Error('SCRIPT_GLOBAL_MISSING'));
      },{once:true});
      script.addEventListener('error',reject,{once:true});
      document.head.appendChild(script);
    });
  }

  function loadCore(sec){
    if(window[CORE_GLOBAL])return Promise.resolve(window[CORE_GLOBAL]);
    if(corePromise)return corePromise;

    const url=sec.dataset.cf61CoreUrl;
    if(!url)return Promise.reject(new Error('CORE_URL_MISSING'));

    corePromise=loadScriptOnce(
      url,
      'data-cf61-core-loader',
      ()=>window[CORE_GLOBAL]||null
    );
    return corePromise;
  }

  function themeUrl(sec,theme){
    const key=THEME_DATASET_KEYS[theme]||THEME_DATASET_KEYS.cinema;
    return sec.dataset[key]||'';
  }

  function loadTheme(sec,theme){
    const registry=ensureThemeRegistry();
    if(registry[theme])return Promise.resolve(registry[theme]);
    if(themePromises.has(theme))return themePromises.get(theme);

    const url=themeUrl(sec,theme);
    if(!url)return Promise.reject(new Error('THEME_URL_MISSING:'+theme));

    const p=loadScriptOnce(
      url,
      'data-cf61-theme-loader-'+theme,
      ()=>ensureThemeRegistry()[theme]||null
    );
    themePromises.set(theme,p);
    return p;
  }

  function fontLink(rec){
    if(!rec?.fontHref)return '';
    const href=String(rec.fontHref).replace(/"/g,'&quot;');
    return '<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>'+
      '<link href="'+href+'" rel="stylesheet">';
  }

  function themePayload(rec,theme,mode){
    return {
      key:theme,
      documentTitle:mode==='mobile'?rec.documentTitleMobile:rec.documentTitleDesktop,
      metaTheme:rec.metaTheme,
      benchmark:rec.benchmark,
      bodyStyle:rec.bodyStyle,
      logoThemeClass:rec.logoThemeClass,
      stageMessages:rec.stageMessages,
      heroLine:rec.heroLine,
      css:mode==='mobile'?rec.mobileCss:rec.desktopCss
    };
  }

  function buildDocument(core,rec,theme,mode){
    return core.templates[mode]
      .replace('__CF61_FONT_LINK__',fontLink(rec))
      .replace('__CF61_THEME_CSS__',mode==='mobile'?rec.mobileCss:rec.desktopCss);
  }

  function applyThemeWithoutReload(sec,rec,theme){
    const frame=sec.querySelector('[data-cf61-banner-frame-r2h]');
    const box=sec.querySelector('[data-cf61-frame-r2h]');
    if(!frame||!box||box.dataset.cf61Loaded!=='1')return false;

    const mode=box.dataset.cf61ActiveSource||(mq.matches?'mobile':'desktop');

    try{
      const api=frame.contentWindow?.__CF61_APPLY_THEME;
      if(typeof api!=='function')return false;

      api(themePayload(rec,theme,mode));

      frame.dataset.cf61ActiveTheme=theme;
      box.dataset.cf61ActiveTheme=theme;
      box.dataset.cf61ActiveKey=theme+'|'+mode;
      return true;
    }catch(_){
      return false;
    }
  }

  async function syncLoadedTheme(sec){
    const box=sec.querySelector('[data-cf61-frame-r2h]');
    if(!box||box.dataset.cf61Loaded!=='1')return false;

    const theme=activeTheme();
    try{
      const rec=await loadTheme(sec,theme);
      return applyThemeWithoutReload(sec,rec,theme);
    }catch(error){
      box.dataset.cf61Error=String(error?.message||error);
      return false;
    }
  }

  async function loadFrame(sec,forceMode=false){
    const frame=sec.querySelector('[data-cf61-banner-frame-r2h]');
    const box=sec.querySelector('[data-cf61-frame-r2h]');
    if(!frame||!box)return;

    const mode=mq.matches?'mobile':'desktop';
    const theme=activeTheme();

    if(!forceMode &&
       box.dataset.cf61Loaded==='1' &&
       box.dataset.cf61ActiveSource===mode){
      await syncLoadedTheme(sec);
      return;
    }

    if(box.dataset.cf61Loading==='1')return;

    box.dataset.cf61Loading='1';
    delete box.dataset.cf61Error;

    try{
      const [core,rec]=await Promise.all([
        loadCore(sec),
        loadTheme(sec,theme)
      ]);

      const latestMode=mq.matches?'mobile':'desktop';
      if(latestMode!==mode){
        delete box.dataset.cf61Loading;
        loadFrame(sec,true);
        return;
      }

      frame.onload=()=>{
        applyThemeWithoutReload(sec,rec,theme);

        box.dataset.cf61Loaded='1';
        box.dataset.cf61Ready='1';
        box.dataset.cf61Deferred='0';
        box.dataset.cf61LoadPolicy='IDLE_NEAR_VIEWPORT';
        delete box.dataset.cf61Loading;
      };

      frame.srcdoc=buildDocument(core,rec,theme,mode);
      frame.dataset.cf61ActiveSource=mode;
      frame.dataset.cf61ActiveTheme=theme;
      box.dataset.cf61ActiveSource=mode;
      box.dataset.cf61ActiveTheme=theme;
      box.dataset.cf61ActiveKey=theme+'|'+mode;
      box.dataset.cf61OracleVideo=core.video||'';
    }catch(error){
      box.dataset.cf61Error=String(error?.message||error);
      delete box.dataset.cf61Loading;
    }
  }

  function cancelIdle(){
    if(!idleHandle)return;
    if(idleKind==='RIC' && 'cancelIdleCallback' in window)cancelIdleCallback(idleHandle);
    else clearTimeout(idleHandle);
    idleHandle=0;
    idleKind='NONE';
  }

  function scheduleIdleLoad(sec){
    const box=sec.querySelector('[data-cf61-frame-r2h]');
    if(!box||box.dataset.cf61Loaded==='1'||box.dataset.cf61Loading==='1')return;
    if(box.dataset.cf61IdleScheduled==='1')return;

    box.dataset.cf61IdleScheduled='1';
    box.dataset.cf61LoadPolicy='IDLE_NEAR_VIEWPORT';

    const run=()=>{
      idleHandle=0;
      idleKind='NONE';
      delete box.dataset.cf61IdleScheduled;
      loadFrame(sec);
    };

    if('requestIdleCallback' in window){
      idleKind='RIC';
      idleHandle=requestIdleCallback(run,{timeout:IDLE_TIMEOUT});
    }else{
      idleKind='TIMEOUT';
      idleHandle=setTimeout(run,64);
    }
  }

  function bind(sec){
    if(sec.dataset.cf61BoundP1R2C==='1')return;
    sec.dataset.cf61BoundP1R2C='1';

    enforceTargetCta(sec);

    const box=sec.querySelector('[data-cf61-frame-r2h]');
    if(box){
      box.dataset.cf61Deferred='1';
      box.dataset.cf61RootMargin=ROOT_MARGIN;
      box.dataset.cf61IdleTimeout=String(IDLE_TIMEOUT);
    }

    let queued=0;
    const syncTheme=()=>{
      cancelAnimationFrame(queued);
      queued=requestAnimationFrame(()=>{
        if(box?.dataset.cf61Loaded==='1')syncLoadedTheme(sec);
      });
    };

    const breakpoint=()=>{
      if(box?.dataset.cf61Loaded==='1')loadFrame(sec,true);
    };

    if(mq.addEventListener)mq.addEventListener('change',breakpoint);
    else mq.addListener(breakpoint);

    // P1-C: the global experience core already publishes one canonical
    // canfoto:experience-change event. Do not observe html/body attributes again.
    let experienceEventCount=0;
    const onExperienceChange=()=>{
      experienceEventCount+=1;
      P1C_STATE.makeup.experienceEventCount=experienceEventCount;
      P1C_STATE.makeup.lastExperienceTheme=activeTheme();
      syncTheme();
    };
    window.addEventListener('canfoto:experience-change',onExperienceChange);

    // CTA markup is static and re-bound on shopify:section:load.
    // A subtree href MutationObserver is therefore unnecessary.
    P1C_STATE.makeup={
      owner:'CANFOTO_EXPERIENCE_EVENT_BUS',
      experienceEventListenerCount:1,
      experienceEventCount,
      themeMutationObserverCount:0,
      legacyBodyThemeObserverCount:0,
      ctaMutationObserverCount:0,
      intersectionObserverCount:('IntersectionObserver' in window)?1:0,
      sectionLifecycleOwner:'BOOT_PLUS_SHOPIFY_SECTION_LOAD',
      activeTheme:activeTheme()
    };

    if(!('IntersectionObserver' in window)){
      scheduleIdleLoad(sec);
      return;
    }

    const io=new IntersectionObserver(entries=>{
      if(!entries.some(entry=>entry.isIntersecting))return;
      io.disconnect();
      scheduleIdleLoad(sec);
    },{
      root:null,
      rootMargin:ROOT_MARGIN,
      threshold:.01
    });

    io.observe(sec);
  }

  function boot(){
    document.documentElement.dataset.cfHomeMakeupCampaign='P1-R2D-P1C';
    document.documentElement.dataset.cfObserverConsolidation='P1C-R1';
    const sec=ensureMounted();
    if(sec)bind(sec);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true});
  }else{
    boot();
  }

  document.addEventListener('shopify:section:load',event=>{
    const sec=event.target?.querySelector?.('[data-cf61-makeup-campaign-r2h]')||ensureMounted();
    if(sec)bind(sec);
  });

  window.debugCanFotoMakeupP1R2C=function(){
    const sec=document.querySelector('[data-cf61-makeup-campaign-r2h]');
    const frame=sec?.querySelector('[data-cf61-banner-frame-r2h]');
    const box=sec?.querySelector('[data-cf61-frame-r2h]');
    const theme=activeTheme();

    let innerTheme=null;
    let video=null;
    let fontLinks=0;
    try{
      innerTheme=frame?.contentDocument?.documentElement?.dataset.cf61InnerTheme||null;
      video=frame?.contentDocument?.querySelector('video.bg')||null;
      fontLinks=frame?.contentDocument?.querySelectorAll('link[href*="fonts.googleapis.com"]').length||0;
    }catch(_){}

    const src=video?.querySelector('source')?.src||video?.currentSrc||'';
    const registry=ensureThemeRegistry();
    const loadedThemeKeys=Object.keys(registry);
    const currentBundleRaw=CORE_RAW_BYTES+(THEME_RAW_BYTES[theme]||0);
    const reductionPct=100-(currentBundleRaw/LEGACY_PAYLOAD_RAW_BYTES*100);

    const legacyResources=performance.getEntriesByType('resource')
      .filter(e=>/canfoto-home-makeup-rgb-campaign-payload\.js/.test(String(e.name||'')));

    const result={
      version:VERSION,
      sectionPresent:!!sec,
      coreLoaded:!!window[CORE_GLOBAL],
      activeThemeShardLoaded:!!registry[theme],
      loadedThemeShardCount:loadedThemeKeys.length,
      loadedThemeKeys,
      legacyPayloadResourceCount:legacyResources.length,
      deferred:box?.dataset.cf61Deferred||null,
      ready:box?.dataset.cf61Ready||null,
      loadPolicy:box?.dataset.cf61LoadPolicy||null,
      rootMargin:box?.dataset.cf61RootMargin||null,
      idleTimeout:box?.dataset.cf61IdleTimeout||null,
      mode:box?.dataset.cf61ActiveSource||null,
      pageTheme:theme,
      innerTheme,
      iframeReloadKey:box?.dataset.cf61ActiveKey||null,
      iframeGoogleFontStylesheetCount:fontLinks,
      currentBundleRawBytes:currentBundleRaw,
      legacyPayloadRawBytes:LEGACY_PAYLOAD_RAW_BYTES,
      initialRawReductionPct:Number(reductionPct.toFixed(1)),
      videoShopifyCdn:src.startsWith('https://cdn.shopify.com/videos/'),
      videoPreload:video?.preload||null,
      error:box?.dataset.cf61Error||null,
      observerConsolidationVersion:P1C_STATE.version,
      observerOwner:P1C_STATE.makeup.owner||null,
      experienceEventListenerCount:P1C_STATE.makeup.experienceEventListenerCount||0,
      experienceEventCount:P1C_STATE.makeup.experienceEventCount||0,
      themeMutationObserverCount:P1C_STATE.makeup.themeMutationObserverCount??null,
      legacyBodyThemeObserverCount:P1C_STATE.makeup.legacyBodyThemeObserverCount??null,
      ctaMutationObserverCount:P1C_STATE.makeup.ctaMutationObserverCount??null
    };

    result.ok=
      result.sectionPresent &&
      result.legacyPayloadResourceCount===0 &&
      result.rootMargin===ROOT_MARGIN &&
      result.loadPolicy==='IDLE_NEAR_VIEWPORT' &&
      (!result.ready || (
        result.ready==='1' &&
        result.coreLoaded &&
        result.activeThemeShardLoaded &&
        result.innerTheme===result.pageTheme &&
        result.iframeGoogleFontStylesheetCount<=1 &&
        result.initialRawReductionPct>=80 &&
        result.videoShopifyCdn &&
        result.videoPreload==='metadata' &&
        result.observerOwner==='CANFOTO_EXPERIENCE_EVENT_BUS' &&
        result.experienceEventListenerCount===1 &&
        result.themeMutationObserverCount===0 &&
        result.legacyBodyThemeObserverCount===0 &&
        result.ctaMutationObserverCount===0 &&
        result.error===null
      ));

    console.table(result);
    return result;
  };
})();
